import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import AdminShell from "../../components/AdminShell";
import { api, apiUrl, formatApiError, formatCDF } from "../../lib/api";
import { Badge, Button, Card, Input, Label } from "../../components/ui-kit";

export default function AdminDisputes() {
  const [items, setItems] = useState([]);
  const [notes, setNotes] = useState({});
  const load = () => api.get("/admin/disputes").then(({ data }) => setItems(data)).catch((e) => toast.error(formatApiError(e)));
  useEffect(() => { load(); }, []);

  const update = async (id, status) => {
    try {
      await api.post(`/admin/disputes/${id}`, {
        status,
        admin_note: notes[id]?.admin_note || "",
        refund_amount: notes[id]?.refund_amount ? Number(notes[id].refund_amount) : null,
      });
      toast.success("Litige mis a jour");
      load();
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  return (
    <AdminShell title="Litiges">
      <div className="admin-page-header">
        <div className="min-w-0">
          <h1 className="responsive-title font-heading text-3xl font-black tracking-tighter sm:text-4xl">Litiges et remboursements</h1>
          <p className="text-sm text-muted-foreground">Suivi des demandes, annulations, notes internes et exports.</p>
        </div>
        <div className="admin-actions">
          <a href={apiUrl("/admin/disputes/export.csv")} target="_blank" rel="noreferrer">
            <Button>CSV</Button>
          </a>
          <a href={apiUrl("/admin/disputes/export.pdf")} target="_blank" rel="noreferrer">
            <Button variant="outline">PDF</Button>
          </a>
        </div>
      </div>
      <div className="mt-5 grid gap-4">
        {items.map((d) => (
          <Card key={d.id} className="p-4 sm:p-5">
            <div className="grid gap-4 xl:grid-cols-[minmax(0,1fr)_340px]">
              <div className="min-w-0 space-y-2">
                <div className="flex flex-wrap items-center gap-2">
                  <Badge tone={d.status === "OPEN" ? "warning" : d.status === "REFUNDED" ? "success" : "primary"}>{d.status}</Badge>
                  <Badge>{d.category}</Badge>
                  {d.ride_id && <span className="font-mono text-xs text-muted-foreground">#{d.ride_id.slice(0, 8)}</span>}
                </div>
                <h2 className="break-words font-heading text-xl font-bold">{d.title}</h2>
                <p className="break-words text-sm text-muted-foreground">{d.message}</p>
                <div className="text-xs text-muted-foreground">
                  Par {d.created_by_name} ({d.created_by_role}) · remboursement demande: {formatCDF(d.requested_refund_amount || 0)}
                </div>
              </div>
              <div className="grid gap-2">
                <div>
                  <Label>Note admin</Label>
                  <Input value={notes[d.id]?.admin_note || ""} onChange={(e) => setNotes((n) => ({ ...n, [d.id]: { ...n[d.id], admin_note: e.target.value } }))} />
                </div>
                <div>
                  <Label>Remboursement</Label>
                  <Input type="number" value={notes[d.id]?.refund_amount || ""} onChange={(e) => setNotes((n) => ({ ...n, [d.id]: { ...n[d.id], refund_amount: e.target.value } }))} />
                </div>
                <div className="grid grid-cols-2 gap-2">
                  <Button variant="outline" className="px-3 text-xs" onClick={() => update(d.id, "IN_REVIEW")}>Revoir</Button>
                  <Button variant="secondary" className="px-3 text-xs" onClick={() => update(d.id, "REFUNDED")}>Rembourser</Button>
                  <Button variant="primary" className="px-3 text-xs" onClick={() => update(d.id, "RESOLVED")}>Resolu</Button>
                  <Button variant="danger" className="px-3 text-xs" onClick={() => update(d.id, "REJECTED")}>Rejeter</Button>
                </div>
              </div>
            </div>
          </Card>
        ))}
        {items.length === 0 && <Card className="p-8 text-center text-sm text-muted-foreground">Aucun litige</Card>}
      </div>
    </AdminShell>
  );
}
